import React from "react"
import _map from "lodash/map"

import classnames from "classnames"
import styles from "./styles.css"

const HistorySkeleton = () => {
  const itemHistoryClasses = classnames(styles.itemHistory, styles.skeleton)
  const containerHistoryItem = classnames(
    "u-flex u-flexJustifyBetween",
    styles.containerHistoryItem
  )
  return (
    <div className={styles.tableHistory}>
      {_map(Array(5), (_, rowIndex) => (
        <div key={rowIndex} className={containerHistoryItem}>
          {_map(Array(5), (_, colIndex) => (
            <div key={colIndex} className={itemHistoryClasses}></div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default HistorySkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/NegotiationSkeleton/HistorySkeleton.js